import script from "./TeamMembersForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeamMembersForm.vue?vue&type=script&setup=true&lang=ts"

import "./TeamMembersForm.vue?vue&type=style&index=0&id=72bc6d1d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72bc6d1d"]])

export default __exports__